import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

const NoDataNoBorder: React.FC = () => (
   
        <Box
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'background.paper',
            }}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="250px"
            width="100%"
        >
            <img src="/static/icons/ci_no_data.svg" alt="" />
            <Typography color="text.secondary" variant="h6">
                No Data
            </Typography>
        </Box>
 
);

export default NoDataNoBorder;
